<template>
    <div id="order_main" class="ui centered container">
        <div class="ui segment">
            <div class="ui text menu">
                <div class="item">
                    <select class="ui simple dropdown" v-model="filter._partner" @change="updatePage()">
                        <option :value="undefined">전체업체</option>
                        <option :value="p._id" v-for="p in getAlivePartners()" :key="p._id">{{ p.name }}</option>
                    </select>
                </div>
                <div class="item">
                    <div class="ui form">
                        <div class="field">
                            <div class="ui calendar" id="calendar_start">
                                <div class="ui input left icon">
                                    <i class="calendar icon"></i>
                                    <input type="text" placeholder="발주날짜(부터)">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <div class="ui form">
                        <div class="field">
                            <div class="ui calendar" id="calendar_end">
                                <div class="ui input left icon">
                                    <i class="calendar icon"></i>
                                    <input type="text" placeholder="발주날짜(까지)">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right menu">
                    <div class="item">
                        <div v-if="isPartner" class="ui primary small button" @click="onAddOrderClick">일반 발주</div>
                    </div>
                    <div class="item">
                        <div class="ui teal small button" @click="download()">다운로드</div>
                    </div>
                    <div class="item">
                        <div class="ui teal small button" @click="downloadExcel">일반 엑셀 양식</div>
                    </div>
                    <div class="item">
                        <div class="ui orange small button" @click="updatePage()">새로고침</div>
                    </div>
                    <div class="item" v-if="user.id =='테스트'">
                        <div class="ui red small button" @click="onTempClick">임시</div>
                    </div>
                </div>
            </div>
            <table class="ui selectable very basic compact table">
                <thead>
                    <tr>
                        <th class="collapsing">#</th>
                        <th>업체</th>
                        <th>발주날짜</th>
                        <th>확정날짜</th>
                        <th>건수</th>
                        <th></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(order, index) in orders" :key="order._id" :class="getSlotColor(order)">
                        <td class="collapsing">{{ index+1 }}</td>
                        <td>{{ order.partnerName }}</td>
                        <td>{{ new Date(order.createdAt).format("yy-MM-dd(KS) HH:mm") }}</td>
                        <td>{{ (order.confirmedAt) ? new Date(order.confirmedAt).format("yy-MM-dd(KS) HH:mm") : "미확정" }}</td>
                        <td>({{ (order.items) ? order.items.length : order.itemCount }}건)</td>
                        <td class="collapsing">
                            <!-- <button :class="order == selected ? 'ui small button' : 'ui small basic button'" @click="onDetailClick(order)">상세보기</button> -->
                            <button v-if="isHeader && order.status == 0" class="ui small orange button" @click="onConfimClick(order)">확정</button>
                        </td>
                        <td class="right collapsing">
                            <div class="ui small icon buttons">
                                <button :class="order == selected ? 'ui grey button' : 'ui basic button'" @click="onDetailClick(order)">
                                    <i class="file outline icon"></i>
                                </button>
                                <button v-if="order.status == 0" class="ui basic button" @click="onRemoveClick(order)">
                                    <i class="trash icon"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>

export default {
    data: function() {
        return { filter: 0, selected: 0, }
    },
    created: function() {
    },
    mounted: function() {
        this.filter = {};
        this.selected = null;
        this.updatePage();
        this.$ui.calendar_StartEnd("#calendar_start", "#calendar_end",
            (date, text) => { this.filter.dateStart = text; },
            (date, text) => { this.filter.dateEnd = text; this.updatePage(); });
    },
    methods: {
        updatePage() {
            this.$event.call("openLoading");
            this.$api.getPageOrder(this.user._id, this.filter, (resData) => {
                this.$event.call("closeLoading");
                if (resData.error) {
                    alert(resData.error.message);
                } else {
                    this.orders = resData.orders;
                    this.centers = resData.centers;
                    this.workers = resData.workers;
                    this.products = resData.products;
                }
            });
        },
        getSlotColor(order) {
            //if (order == this.selected) return "grey";
            if (!order.confirmedAt) return "yellow";
            return "";
        },
        onStockClick() {
            if (this.isPartner) {
                this.$event.call("openStockModal", this.user);
            }
        },
        onAddOrderClick() {
            this.$event.call("open_new_order", () => this.updatePage());
        },
        onDetailClick(order) {
            this.selected = order;

            if (order.items) {
                this.$event.call("openOrderDetail2", order);
            }
            else {
                this.$event.call("openOrderDetail", order);
            }
        },
        onConfimClick(order) {
            this.$event.call("openConfirmOrder", order, () => this.updatePage());
        },
        onRemoveClick(order) {
            this.$event.call("openPopup", "발주 삭제하시겠습니까?", "", () => {
                this.$event.call("closePopup");
                this.$event.call("openLoading");
                this.$api.deleteOrder(order._id, (resData) => {
                    this.$event.call("closeLoading");
                    if (resData.error){
                        alert(resData.error.message);
                    } else {
                        this.updatePage();
                    }
                });
            });
        },
        download()
        {
            this.$event.call("openLoading");

            this.$api.getAllOrder(this.user._id, this.filter, (resData) =>
            {
                this.$event.call("closeLoading");

                if (resData.error)
                {
                    alert(resData.error.message);
                }
                else
                {                    
                    this.$excel.downloadOrder(this, resData.items, "발주내역");
                }
            });
        },
        downloadExcel() {
            const aoa = [];
            aoa.push(["#", "타입", "주문날짜", "판매처", "상품명", "수량", "주문자", "주문자연락처", "수취인", "수취인연락처", "수취인주소", "고객요청사항", "설치유형", ]);
            aoa.push(["1", "배송", "2020/01/01", "쿠팡", "ABCD1234", "1", "홍길동", "010-1234-5678", "홍길동", "010-1234-5678", "서울특별시 강남구 청담동 66 청담근린공원", "경비실에 맡겨주세요", "" ]);
            aoa.push(["2", "설치", "2020/01/01", "네이버", "ABCD1234", "1", "홍길동", "010-1234-5678", "홍길동", "010-1234-5678", "서울특별시 강남구 청담동 66 청담근린공원", "배송전에 연락주세요", "브라켓(상하좌우)설치" ]);
            aoa.push(["3", "교환", "2020/01/01", "", "ABCD1234", "1", "홍길동", "010-1234-5678", "홍길동", "010-1234-5678", "서울특별시 강남구 청담동 66 청담근린공원", "", "" ]);
            aoa.push(["4", "회수", "2020/01/01", "", "ABCD1234", "1", "홍길동", "010-1234-5678", "홍길동", "010-1234-5678", "서울특별시 강남구 청담동 66 청담근린공원", "", "" ]);
            aoa.push(["5", "AS", "2020/01/01", "", "ABCD1234", "1", "홍길동", "010-1234-5678", "홍길동", "010-1234-5678", "서울특별시 강남구 청담동 66 청담근린공원", "", "" ]);

            const wb = this.$excel.newWorkBook();
            const ws = this.$excel.addWorkSheet(wb, "주문내역", aoa);
            this.$excel.setColSizes(ws, [ 3, 5, 13, 8, 13, 4, 8, 15, 8, 15, 50, 25, 30, ]);
            this.$excel.saveFile(wb, new Date().format("yyyyMMdd_") + this.user.name + "_일반양식");
        },
        getAlivePartners()
        {
            const array = [];
            for (const partner of this.partners)
            {
                if (!partner.isTerminated) array.push(partner);
            }
            return array;
        },
        onTempClick() {
            this.$event.call("openLoading");
            this.$api.temp((resData) => {
                this.$event.call("closeLoading");
                alert(resData.message);

                console.dir(resData.orders);
                console.dir(resData.parcelOrders);
            });
        }
    },
    computed: {
        user: function() { return this.$store.getters.user; },
        partners: function() { return this.$store.getters.partners; },
        workers: function() { return this.$store.getters.workers; },
        constantNames: function() { return this.$store.getters.constantNames; },
        isHeader: function() { return this.$store.getters.isHeader; },
        isPartner: function() { return this.$store.getters.isPartner; },
        orders: {
            get: function() { return this.$store.getters.orders; },
            set: function(val) { return this.$store.commit("setOrders", val); },
        },
        centers: {
            get: function() { return this.$store.getters.centers; },
            set: function(val) { this.$store.commit("setCenters", val); },
        },
        workers: {
            get: function() { return this.$store.getters.workers; },
            set: function(val) { return this.$store.commit("setWorkers", val); },
        },
        products: {
            get: function() { return this.$store.getters.products; },
            set: function(val) { this.$store.commit("setProducts", val); },
        },
    },
};
</script>

<style>
#order_main {
    margin-top:15px;
}
#order_main .segment {
    min-height: 800px;
}
#order_main .ui.text.menu {
    margin: 0;
    width: 100%;
}

</style>


// WEBPACK FOOTER //
// src/components/OrderMain.vue